import {
    TypeAgencyIcon,
    TypeCustomerIcon,
    TypeDistributorIcon,
    TypeResellerIcon
} from '../../../../utils/SVGIcon';

function CustomerTypeList({ data }) {
    const typeIcon = [
        {
            key: 'agency',
            icon: <TypeAgencyIcon />
        },
        {
            key: 'reseller',
            icon: <TypeResellerIcon />
        },
        {
            key: 'distributor',
            icon: <TypeDistributorIcon />
        },
        {
            key: 'customer',
            icon: <TypeCustomerIcon />
        }
    ];

    return (
        <div className="customer_type ">
            <div className="customer_type_title mb-4">
                <h3 className="text-lg font-medium text-primary">Customer Type</h3>
            </div>
            <div className="customer_type_body flex flex-wrap justify-start items-center gap-2 md:gap-5">
                {data?.map((item) => {
                    if (item?.key === 'admin') return null;

                    return (
                        <div
                            key={item?.key}
                            className="w-full md:w-64 flex flex-wrap justify-start items-center gap-4 bg-white-100 p-2 md:p-4.5 border border-primary-100 rounded-10 md:rounded-[15px]"
                        >
                            <div className="w-8 md:w-12 text-secondary">
                                {typeIcon?.find((icon) => icon?.key === item?.key)?.icon}
                            </div>
                            <h4 className="text-base md:text-xl font-medium text-primary">
                                {item?.title}
                            </h4>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CustomerTypeList;
